<template>
  <address class="support-contacts">
    <div class="support-contacts__left">
      <div class="support-contacts__caption">
        {{title}}
      </div>
      <div class="support-contacts__column">
        <div class="support-contacts__tel-row">
          <a
            v-bind:href="$options.supportPhoneHref"
            class="support-contacts__tel">
            {{ $options.supportPhoneTitle }}
          </a>
          <whats-mini-button
            v-if="isShowMiniButtonWhatsApp"
          />
        </div>
        <a
          v-bind:href="$options.supportEmailHref"
          class="support-contacts__email">
          {{ $options.supportEmailTitle }}
        </a>
      </div>
    </div>
    <div class="support-contacts__right">
      <slot />
      <a
        v-if="isShowLargeButtonWhatsApp"
        class="support-contacts__button wa"
        rel="noopener noreferrer"
        target="_blank"
        v-bind:href="$options.supportWhatsappHref">
        WhatsApp
      </a>
    </div>
  </address>
</template>

<script>
import aboutMixin from '@/mixins/aboutMixin';
import WhatsMiniButton from '@/components/WhatsMiniButton.vue';

export default {
  components: { WhatsMiniButton },
  mixins: [aboutMixin],
  props: {
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: { required: true, type: String },
    /**
     * @description Показываем большую кнопку whats-app.
     * @type {string}
     */
    isShowLargeButtonWhatsApp: { type: Boolean, default: true },
    /**
     * @description Показываем мини кнопку whats-app.
     * @type {string}
     */
    isShowMiniButtonWhatsApp: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.support-contacts {
  background: #EAEFF3;
  padding: 42px 42px 50px 46px;
  display: grid;
  grid-template-columns: 1fr 333px;
  grid-gap: 50px;
  font-style: normal;
  &__tel-row {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  &__left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__caption {
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    margin: 0 0 10px 0;
    white-space:pre-line;
  }
  &__column {
    display: flex;
    flex-direction: column;
    grid-gap: 14px;
  }
  &__tel {
    font-weight: 700;
    font-size: 28px;
    line-height: 34px;
    color: #000000 !important;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  &__email {
    color: #0489E0;
    font-weight: 400;
    font-size: 28px;
    line-height: 34px;
    &:hover {
      text-decoration: none;
    }
  }
  &__right {
    display: flex;
    flex-direction: column;
    margin: auto 0 0 0;
  }
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    max-width: 333px;
    width: 100%;
    border-radius: 6px;
    font-weight: 400;
    font-size: 22px;
    line-height: 26px;
    letter-spacing: 0.25px;
    color: #FFFFFF !important;
    text-decoration: none;
    &:before {
      content: '';
      width: 26px;
      min-width: 26px;
      height: 26px;
      min-height: 26px;
      background-size: contain;
      margin: 0 15px 0 0;
    }
    &.tg {
      background: #40B3E0;
      &:hover {
        background: #0489E0;
      }
      &:before {
        background-image: url("@/assets/img/social/telegram-white.svg");
      }
    }
    &.wa {
      background: #4BC389;
      &:hover {
        background: #16905a;
      }
      &:before {
        background-image: url("@/assets/img/social/whats-white.svg");
      }
    }
  }
}
@media screen and (max-width: 1060px) {
  .support-contacts {
    grid-template-columns: 1fr;
    grid-gap: 0;
    &__caption {
      margin: 0 0 20px 0;
    }
    &__right {
      padding-top: 47px;
    }
  }
}

@media screen and (max-width: 480px) {
  .support-contacts {
    padding: 20px 15px;
  }
}
</style>
